// extracted by mini-css-extract-plugin
module.exports = {"roadmap":"index_roadmap__RnlED","pl20":"index_pl20__eUazO","wSlide":"index_wSlide__V1XD8"};